import React from 'react'
import Container from '../ui/comp/Container'
import img from '../assets/empty-state-media.svg'

function NoContent() {


    return (
        <div className='w-full relative mt-8'>
            <Container>
                <div className="py-10 px-5 relative flex justify-center items-center space-y-1 flex-col">
                    <img src={img} alt="" className='max-w-52 mx-auto w-full' />
                    <p className="text-gray-500 text-sm">No Content Found Here</p>
                </div>
            </Container>
        </div>
    )
}

export default NoContent